<template>
  <div class="sales-toolbar-root">
    <div
      class="bg-red-darken-3 sales-toolbar-strip pt-2 pb-2 pb-md-3 px-3 px-md-6 px-lg-8"
    >
      <v-row
        align="center"
        class="sales-toolbar-search-row flex-wrap"
        no-gutters
      >
        <v-col
          cols="auto"
          class="d-none d-md-flex align-center flex-shrink-0 sales-toolbar-brand ga-3"
        >
          <div class="text-subtitle-1 text-white text-truncate">
            {{ $t("sales.label") }}
          </div>
          <v-divider class="flex-shrink-0" inset vertical />
        </v-col>

        <v-spacer class="d-none d-md-flex" />

        <v-col
          cols="12"
          md="auto"
          class="sales-toolbar-right flex-grow-1 min-width-0"
        >
          <div
            class="d-flex flex-wrap align-center ga-2 ga-md-3 w-100 justify-start justify-md-end"
          >
            <v-btn
              color="grey-darken-4"
              variant="flat"
              class="flex-shrink-0 sales-toolbar-export-btn"
              :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
              @click="exportToExcel"
            >
              {{ $t("sales.export") }}
              <v-icon end>mdi-file-excel-outline</v-icon>
            </v-btn>

            <div class="sales-toolbar-fields flex-grow-1 min-width-0">
              <!--SEARCH BY TITLE-->
              <v-autocomplete
                v-if="searchType === 'title'"
                v-model="titleCode"
                v-model:search="searchTitle"
                v-model:menu="menuOpen"
                :loading="loadingTitle"
                :items="titles"
                :label="$t('parts.inventory.search')"
                item-value="partCode"
                :item-title="() => ''"
                :custom-filter="customFilter"
                variant="solo"
                color="grey-darken-4"
                append-inner-icon="mdi-magnify"
                single-line
                hide-details
                hide-no-data
                clearable
                autocomplete="off"
                class="sales-field-on-red"
                @keyup.enter="searchMethod"
                @click:append-inner="searchMethod"
                @update:search="updateSearch"
              >
                <template #item="{ item, props }">
                  <v-list-item
                    v-bind="props"
                    class="listRowColor"
                    @click="selectCode(item)"
                  >
                    <div class="text-start pa-2">
                      <span class="caption">Info Car - </span>
                      <span
                        class="font-weight-bold"
                        v-html="
                          highlight(
                            item?.raw?.title?.[$store.getters.language] ||
                              'No Title',
                            searchTitle,
                          )
                        "
                      />
                    </div>

                    <div
                      v-if="item?.raw?.related?.length"
                      class="related-scroll hidden-sm-and-down pa-2"
                    >
                      <span
                        v-for="(el, idx) in item.raw.related"
                        :key="idx"
                        class="mr-2"
                        style="font-size: 10px"
                        v-html="
                          highlight(
                            el?.title?.[$store.getters.language] ||
                              'No Related Title',
                            searchTitle,
                          )
                        "
                      />
                    </div>
                  </v-list-item>
                </template>
                <template #selection="{ item }">
                  <span v-if="item">
                    {{ item?.raw?.title?.[$store.getters.language] }}
                  </span>
                </template>
              </v-autocomplete>
              <!--SERCH OTHER FIELDS-->
              <v-text-field
                v-else
                v-model="search"
                :label="$t('sales.search')"
                flat
                variant="solo"
                color="grey-darken-4"
                append-inner-icon="mdi-magnify"
                single-line
                hide-details
                class="sales-field-on-red"
                @keyup.enter="!advancedSearch ? searchMethod() : ''"
                @click:append-inner="searchMethod()"
              />
            </div>

            <v-select
              v-model="searchType"
              :items="searchTypes"
              item-title="label"
              item-value="value"
              color="grey-darken-4"
              variant="solo"
              flat
              hide-details
              class="sales-field-on-red sales-toolbar-type-select mt-2 mt-md-0 flex-shrink-0"
            />

            <v-btn
              color="grey-darken-4"
              size="small"
              variant="flat"
              class="mt-2 mt-md-0 flex-shrink-0 sales-toolbar-advanced-btn"
              @click="advancedSearch = !advancedSearch"
            >
              <v-icon start>
                {{
                  advancedSearch
                    ? "mdi-checkbox-marked-outline"
                    : "mdi-checkbox-blank-outline"
                }}
              </v-icon>
              {{ $t("parts.inventory.advanced") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>

    <div class="redColor pa-3 pa-md-4">
      <!---------------------------------------ADVANCED SEARCH--------------------------------------->
      <div v-if="advancedSearch" class="sales-advanced-search-panel">
        <v-row
          class="sales-advanced-search-grid pb-2 px-2 px-sm-4 flex-wrap align-center"
        >
          <!-------------------------------------------BRAND------------------------------------------->
          <v-col cols="12" sm="6" xl="3" lg="3">
            <v-autocomplete
              v-model="brand"
              :items="brands"
              :loading="loadingBrand"
              :label="$t('parts.advanced_search.brand')"
              item-title="title"
              autocomplete="off"
              flat
              variant="solo"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              @click:append-inner="brand = null"
            >
              <!-- Custom dropdown item -->
              <template #item="{ props, item }">
                <v-list-item v-bind="props">
                  <template #prepend>
                    <v-img
                      :src="item.raw.logo"
                      height="35"
                      width="35"
                      class="mr-3"
                      cover
                    />
                  </template>
                  <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
                </v-list-item>
              </template>

              <!-- Selected value in the field -->
              <template #selection="{ item }">
                <div class="d-flex align-center">
                  <v-img
                    :src="item.raw.logo"
                    height="35"
                    width="35"
                    class="mr-3"
                    cover
                  />
                  <span>{{ item.raw.title }}</span>
                </div>
              </template>
            </v-autocomplete>
          </v-col>
          <!-------------------------------------------MODEL------------------------------------------->
          <v-col cols="12" sm="6" xl="4" lg="4">
            <v-combobox
              v-model="model"
              :items="models"
              :loading="loadingModel"
              :label="!model ? $t('parts.advanced_search.model') : ''"
              item-title="description"
              item-value="modelCode"
              autocomplete="off"
              variant="solo"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              class="car-search-combobox"
              @click:append-inner="model = null"
            >
              <!-- Dropdown items -->
              <template #item="{ props, item }">
                <v-list-item v-bind="props">
                  <v-list-item-content>
                    <v-row>
                      <!-- Description -->
                      <v-col cols="12" md="4" class="bg-grey-lighten-3 mt-2">
                        <div class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.model")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </div>
                      </v-col>

                      <!-- Year range -->
                      <v-col
                        cols="12"
                        md="8"
                        class="bg-grey-lighten-3 mt-2"
                      >
                        <div class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!-- Selected value -->
              <template #selection="{ item }">
                <div
                  class="car-detail-selection d-flex justify-between align-center pa-2 w-100"
                >
                  <div class="car-detail-col d-flex flex-column pr-2">
                    <span class="caption">{{
                      $t("parts.advanced_search.model")
                    }}</span>
                    <span class="font-weight-bold">{{
                      item.raw.description
                    }}</span>
                  </div>
                  <div class="car-detail-col d-flex flex-column">
                    <span class="caption">{{
                      $t("parts.advanced_search.year")
                    }}</span>
                    <span class="font-weight-bold">
                      {{ formatMonthYear(item.raw.startingDate) }} -
                      {{ formatMonthYear(item.raw.endingDate) }}
                    </span>
                  </div>
                </div>
              </template>
            </v-combobox>
          </v-col>
          <!------------------------------------------VERSION------------------------------------------>
          <v-col cols="12" xl="5" lg="5">
            <v-combobox
              v-model="version"
              :items="versions"
              :loading="loadingVersion"
              :label="!version ? $t('parts.advanced_search.version') : ''"
              item-title="fullDescription"
              item-value="versionCode"
              flat
              variant="solo"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              class="car-search-combobox car-search-version-combobox"
              @click:append-inner="version = null"
            >
              <!-- Dropdown items -->
              <template #item="{ item, props }">
                <v-list-item v-bind="props">
                  <div
                    class="d-sm-none car-version-detail-item bg-grey-lighten-3 mt-2 pa-3 w-100"
                  >
                    <div
                      class="car-version-detail-row car-version-detail-row--dropdown"
                    >
                      <div
                        class="car-version-detail-col car-version-detail-col--main"
                      >
                        <span class="caption">{{
                          $t("parts.advanced_search.version")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                        </span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </div>
                      <div class="car-version-detail-col">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>&nbsp;
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </div>
                    </div>
                  </div>
                    <v-row class="d-none d-sm-flex pa-3 bg-grey-lighten-3 mt-2">
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }} kw,
                          </span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                </v-list-item>
              </template>

              <!--SELECTED-->
              <template #selection="{ item }">
                <div class="car-version-detail-selection car-detail-selection w-100 d-sm-none">
                  <div class="car-version-detail-row">
                    <div
                      class="car-version-detail-col car-version-detail-col--main"
                    >
                      <span class="caption">
                        {{ $t("parts.advanced_search.version") }}
                      </span>
                      <span class="font-weight-bold">{{
                        item.raw.description
                      }}</span>
                    </div>
                    <div class="car-version-detail-col">
                      <span class="caption">{{
                        $t("parts.advanced_search.year")
                      }}</span>
                      <span class="font-weight-bold">
                        {{ formatMonthYear(item.raw.startingDate) }} -
                        {{ formatMonthYear(item.raw.endingDate) }}
                      </span>
                    </div>
                    <div class="car-version-detail-col">
                      <span class="caption">{{
                        $t("parts.advanced_search.body")
                      }}</span>
                      <span class="font-weight-bold">{{
                        item.raw.numberOfDoors
                      }}</span>
                    </div>
                    <div class="car-version-detail-col">
                      <span class="caption">{{
                        $t("parts.advanced_search.power")
                      }}</span>
                      <span class="font-weight-bold">
                        {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                      </span>
                    </div>
                    <div class="car-version-detail-col">
                      <span class="caption">{{
                        $t("parts.advanced_search.engine")
                      }}</span>
                      <span class="font-weight-bold">{{
                        item.raw.engineCode
                      }}</span>
                    </div>
                    <div class="car-version-detail-col">
                      <span class="caption">{{
                        $t("parts.advanced_search.supply.supply")
                      }}</span>
                      <span class="font-weight-bold">{{
                        getSupplyLocale(item.raw.supplyCode)
                      }}</span>
                    </div>
                  </div>
                </div>
                  <v-row class="pa-2 d-none d-sm-flex">
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }} kw,
                        </span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
              </template>
            </v-combobox>
          </v-col>
          <!------------------------------------------STATUS------------------------------------------->
          <v-col cols="12" lg="12">
            <v-select
              v-model="advancedSearchItems.status"
              :items="statusItems"
              :label="$t('sales.status.label')"
              :hint="$t('sales.status.hint')"
              item-title="title"
              item-value="value"
              variant="solo"
              flat
              chips
              closable-chips
              multiple
              color="black"
              prepend-icon="mdi-information"
              class="w-100"
              persistent-hint
            />
          </v-col>
          <!----------------------------------------START DATE----------------------------------------->
          <v-col cols="12" sm="6" md="4" lg="3" class="pr-2">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="advancedSearchItems.startDate"
                  :value="formatDateToDisplay(advancedSearchItems.startDate)"
                  :label="$t('parts.advanced_search.starting_date')"
                  :hint="$t('parts.advanced_search.select_starting_date')"
                  variant="solo"
                  flat
                  color="black"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="props"
                />
              </template>

              <v-date-picker
                v-model="advancedSearchItems.startDate"
                color="red-darken-3"
                :max="advancedSearchItems.endDate || null"
                @update:model-value="startDateMenu = false"
              />
            </v-menu>
          </v-col>
          <!-----------------------------------------END DATE------------------------------------------>
          <v-col cols="12" sm="6" md="4" lg="3" class="pr-2">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-model="advancedSearchItems.endDate"
                  :value="formatDateToDisplay(advancedSearchItems.endDate)"
                  :label="$t('parts.advanced_search.ending_date')"
                  :hint="$t('parts.advanced_search.select_ending_date')"
                  variant="solo"
                  flat
                  color="black"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="props"
                />
              </template>

              <v-date-picker
                v-model="advancedSearchItems.endDate"
                color="red-darken-3"
                :min="advancedSearchItems.startDate || null"
                @update:model-value="endDateMenu = false"
              />
            </v-menu>
          </v-col>
          <!---------------------------------------INSTITUTIONS---------------------------------------->
          <v-col
            v-if="
              $store.getters.role === 'LekoAdmin' ||
              $store.getters.role === 'LekoEmployee' ||
              $store.getters.role === 'SuperAdmin'
            "
            cols="12"
            md="6"
            lg="6"
          >
            <v-autocomplete
              v-model="advancedSearchItems.institution"
              :items="institutions"
              :loading="loadingInstitution"
              :label="$t('sales.institution')"
              :hint="$t('sales.select_institution')"
              item-title="title"
              item-value="_id"
              autocomplete="off"
              flat
              variant="solo"
              color="grey-darken-4"
              prepend-icon="domain"
              persistent-hint
            />
          </v-col>
          <!------------------------------------------CLIENT------------------------------------------->
          <v-col cols="12" md="3" lg="3" class="pr-3 pl-1">
            <v-autocomplete
              v-model="advancedSearchItems.client"
              :items="clients"
              :loading="loadingClient"
              :label="$t('sales.client')"
              :hint="$t('sales.select_client')"
              :item-title="clientDisplayTitle"
              :custom-filter="clientAutocompleteFilter"
              item-value="_id"
              color="grey-darken-4"
              variant="solo"
              autocomplete="off"
              flat
              prepend-icon="mdi-account"
              persistent-hint
              clearable
            />
          </v-col>
          <!-------------------------------------------PRICE------------------------------------------->
          <v-col cols="12" md="8" lg="3" class="pl-2">
            <v-row class="flex-wrap align-center justify-center mb-4">
              <v-col cols="12" sm="10" lg="12" class="pr-2 d-flex">
                <v-range-slider
                  v-model="advancedSearchItems.price"
                  :label="$t('sales.price_range')"
                  :max="50000"
                  :min="0"
                  :step="1000"
                  color="grey-darken-4"
                />
                <!-- </v-col>

          <v-col
            xs="4"
            sm="2"
            lg="4"
            pl-3
          > -->
                <span class="mt-1">
                  {{ advancedSearchItems.price[0] }}-{{
                    advancedSearchItems.price[1]
                  }}
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="justify-center align-center pb-4 px-2 flex-wrap ga-2">
          <v-btn
            dark
            color="grey-darken-4"
            class="mx-1"
            @click="clearSearchFields"
          >
            {{ $t("parts.advanced_search.clear") }}
            <v-icon end> mdi-notification-clear-all </v-icon>
          </v-btn>
          <v-btn dark color="grey-darken-4" class="mx-1" @click="searchMethod">
            {{ $t("parts.advanced_search.search") }}
            <v-icon end> mdi-magnify </v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import * as XLSX from "xlsx";
import getRequest from "../../api/getRequest";
import {
  clientAutocompleteFilter,
  clientDisplayTitle,
} from "../../utils/clientDisplay";
import { useDisplay } from "vuetify";

export default {
  components: {},
  filters: {
    moment(date) {
      moment.locale(localStorage.getItem("language"));
      const valid = moment(date).isValid();
      if (valid) return moment(date).format("MM/YYYY");
      return "";
    },
  },
  props: ["items"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    searchTypes: [
      { label: "Title", value: "title" },
      { label: "ID", value: "id" },
      { label: "Other", value: "other" },
      { label: "PRA", value: "pra" },
    ],
    searchType: "title",
    advancedSearch: false,
    search: "",
    searchTitle: null,
    titleCode: null,
    titles: [],
    brands: [],
    models: [],
    versions: [],
    brand: null,
    model: null,
    version: null,
    statusItems: [
      { title: "Sold-Online", value: 1.0 },
      { title: "Sold-Desk", value: 1.1 },
      // { title: 'Sold-Ebay', value: 1.2 }, // ebay via multibreves
      { title: "Returned", value: 2.0 },
      { title: "Returned-Inventory", value: 2.1 },
      { title: "Returned-Damaged", value: 2.2 },
      { title: "Sold-Ebay-Leko", value: 2.3 },
      { title: "Sold-ReteRicambi", value: 2.4 },
    ],
    startDateMenu: false,
    endDateMenu: false,
    institutions: [],
    clients: [],

    advancedSearchItems: {
      brand: null,
      model: null,
      version: null,
      status: [1.0, 1.1, 2.0, 2.1, 2.2, 2.3, 2.4],
      startDate: "",
      endDate: "",
      institution: null,
      client: null,
      price: [0, 50000],
    },
    loadingTitle: false,
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
    loadingInstitution: false,
    loadingClient: false,
    menuOpen: false,
    selectingItem: false,
    searchTimeout: null,
  }),
  computed: {
    display() {
      return useDisplay();
    },
  },
  watch: {
    search(value) {
      if (!value && this.advancedSearch === false) this.$emit("clear-search");
    },
    searchTitle(newValue) {
      if (this.selectingItem) {
        this.selectingItem = false;
        return;
      }
      if (!newValue) {
        this.titles = [];
        this.menuOpen = false;
        return;
      }
      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(async () => {
        if (newValue) {
          this.loadingTitle = true;
          try {
            const response = await getRequest(
              "/info-car/parts",
              `title=${encodeURIComponent(newValue)}&language=${this.$store.getters.language}`,
            );
            await this.$nextTick();
            this.titles = response.parts || [];
          } catch (error) {
            this.titles = [];
          } finally {
            this.loadingTitle = false;
            this.menuOpen = this.titles.length > 0;
          }
        } else {
          this.titles = [];
          this.menuOpen = false;
        }
      }, 350); // 300ms delay
    },
    advancedSearch(value) {
      if (value) {
        this.getBrands();
        this.getClients();
        if (
          this.$store.getters.role === "LekoAdmin" ||
          this.$store.getters.role === "LekoEmployee" ||
          this.$store.getters.role === "SuperAdmin"
        ) {
          this.getInstitutions();
        }
      } else {
        this.advancedSearchItems = {
          brand: null,
          model: null,
          version: null,
          status: [1.0, 1.1, 2.0, 2.1, 2.2, 2.3, 2.4],
          startDate: "",
          endDate: "",
          institution: null,
          client: null,
          price: [0, 50000],
        };
      }
    },
    "advancedSearchItems.institution": {
      handler(value) {
        if (value) {
          this.getClientsByInst(value);
        } else if (this.advancedSearch) {
          this.getClients();
        }
      },
    },
    brand(value) {
      if (value) {
        this.models = [];
        this.model = null;
        this.versions = [];
        this.version = null;
        this.getModels(value.brandCode);
        this.advancedSearchItems.brand = value.brandCode;
      } else {
        this.advancedSearchItems.brand = null;
      }
    },
    model(value) {
      if (value) {
        this.versions = [];
        this.version = null;
        this.getVersions(value.brandCode, value.modelCode);
        this.advancedSearchItems.model = value.modelCode;
      } else {
        this.advancedSearchItems.model = null;
      }
    },
    version(value) {
      if (value) this.advancedSearchItems.version = value.versionCode;
      else this.advancedSearchItems.version = null;
    },
    "$i18n.locale"() {
      this.getLocale();
    },
  },
  created() {
    this.getLocale();
  },
  methods: {
    clientDisplayTitle,
    clientAutocompleteFilter,
    getLocale() {
      this.searchTypes[0].label = this.$t("sales.title");
      this.searchTypes[1].label = this.$t("sales.id");
      this.searchTypes[2].label = this.$t("sales.other");
      this.statusItems[0].title = this.$t("sales.status.sold_online");
      this.statusItems[1].title = this.$t("sales.status.sold_desk");
      // this.statusItems[2].title = this.$t('sales.status.sold_ebay');
      this.statusItems[2].title = this.$t("sales.status.returned");
      this.statusItems[3].title = this.$t("sales.status.returned_inventory");
      this.statusItems[4].title = this.$t("sales.status.returned_damaged");
      this.statusItems[5].title = this.$t("sales.status.sold_ebay_leko");
      this.statusItems[6].title = `${this.$t("parts.status.sold")} ReteRicambi`;
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
    searchMethod() {
      if (this.advancedSearch) {
        // ADVANCED
        this.$emit("advanced-search", {
          type: this.searchType,
          searchField: this.search,
          titleCode: this.titleCode,
          advancedSearchItems: this.advancedSearchItems,
        });
      } else if (this.search.length > 0 || this.titleCode) {
        // REGULAR
        this.$emit("search", {
          type: this.searchType,
          searchField: this.search,
          titleCode: this.titleCode,
        });
      }
    },
    clearSearchFields() {
      this.search = "";
      this.titleCode = null;
      this.advancedSearchItems = {
        brand: null,
        model: null,
        version: null,
        status: [1.0, 1.1, 2.0, 2.1, 2.2, 2.3, 2.4],
        startDate: "",
        endDate: "",
        institution: null,
        client: null,
        price: [0, 50000],
      };
      this.brand = null;
      this.model = null;
      this.version = null;
      this.$emit("clear-search");
    },
    getClients() {
      this.loadingClient = true;
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingClient = false;
        });
    },
    getClientsByInst(id) {
      this.loadingClient = true;
      getRequest(
        "/client/institution",
        `role=${this.$store.getters.role}&institution_id=${id}`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingClient = false;
        });
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInstitution = false;
        });
    },

    getBrands() {
      this.loadingBrand = true;
      getRequest("/info-car/brands")
        .then((response) => {
          this.brands = response.brands;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getModels(brandCode) {
      this.loadingModel = true;
      getRequest("/info-car/models", `brand_code=${brandCode}`)
        .then((response) => {
          this.models = response.models;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingModel = false;
        });
    },
    getVersions(brandCode, modelCode) {
      this.loadingVersion = true;
      getRequest(
        "/info-car/versions",
        `brand_code=${brandCode}&model_code=${modelCode}`,
      )
        .then((response) => {
          this.versions = response.versions;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingVersion = false;
        });
    },
    highlight(title, search) {
      let result = title || "";
      if (search) {
        const index = title
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase());
        // mark the text.
        if (index > -1)
          result = [
            title.slice(0, index),
            "<mark>",
            title.slice(index, index + search.length),
            "</mark>",
            title.slice(index + search.length),
          ].join("");
      }
      return `<span>${result}</span>`;
    },
    setId(id) {
      this.searchType = "id";
      this.search = id;
    },
    async exportToExcel() {
      const data = await this.exportData();

      // Create a worksheet
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook and append the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sales");

      // Trigger download
      XLSX.writeFile(wb, "sales.xlsx");
    },
    exportData() {
      const items = [];
      this.$props.items.forEach((item) => {
        const itemObject = {
          Status: item.status,
          "Part ID": item.part.old_id,
          Title: item.part.title,
          Price: `${item.part.price} ${item.part.currency}`,
          "Date Created": moment(item.date_created).format("DD-MM-YYYY LT"),
          Warranty: item.warranty.title,
          "Return Date": moment(item.return_date).format("DD-MM-YYYY"),
          Client: `${item.client ? item.client.name + "" + item.client.surname : item.customShopPlatformSold}`,
          Debt: item.debt,
          Notes: item.notes,
        };
        items.push(itemObject);
      });
      return items;
    },
    scanQr() {},
    formatDateToDisplay(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0"); // 0-indexed
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("LLL");
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    selectCode(item) {
      this.titleCode = item.raw?.partCode || item.partCode || item.value;
      this.selectingItem = true;
      this.$nextTick(() => {
        this.searchMethod();
      });
    },
    customFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const searchText = queryText.toLowerCase();
      const language = this.$store.getters.language;

      // Check main title
      const mainTitle = itemText.raw?.title?.[language]?.toLowerCase() || "";
      if (mainTitle.includes(searchText)) return true;

      // Check related titles
      const relatedTitles = itemText.raw?.related || [];
      return relatedTitles.some((related) => {
        const relatedTitle = related?.title?.[language]?.toLowerCase() || "";
        return relatedTitle.includes(searchText);
      });
    },
    updateSearch() {
      // optional hook for @update:search
    },
  },
};
</script>
<style scoped>
.related-scroll {
  overflow-x: auto;
  white-space: nowrap;
  margin-top: -8px;
  max-width: 700px;
}

.related-scroll span {
  white-space: nowrap;
}

/* Top search strip */
.sales-toolbar-strip {
  position: relative;
  z-index: 1;
  width: 100%;
}

.sales-toolbar-root .min-width-0 {
  min-width: 0;
}

.sales-toolbar-root :deep(.sales-field-on-red .v-field) {
  min-width: 0;
}

@media (min-width: 960px) {
  .sales-toolbar-root .sales-toolbar-right {
    flex: 1 1 auto;
    min-width: 0;
    max-width: none;
  }

  .sales-toolbar-root .sales-toolbar-search-row {
    align-items: center;
  }

  .sales-toolbar-root .sales-toolbar-brand {
    max-width: min(38vw, 26rem);
  }
}

.sales-toolbar-root .sales-toolbar-type-select {
  width: min(100%, 11rem);
}

@media (min-width: 960px) {
  .sales-toolbar-root .sales-toolbar-type-select {
    width: 9.25rem;
  }
}

.sales-advanced-search-panel {
  overflow-x: hidden;
}

/* Model/version combobox mobile layout */
@media (max-width: 959px) {
  .sales-toolbar-root .car-version-detail-selection {
    width: 100%;
    padding: 0.375rem 0.25rem;
  }

  .sales-toolbar-root .car-version-detail-row {
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    gap: 0.75rem 1rem;
  }

  .sales-toolbar-root .car-version-detail-col {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    min-width: 0;
    flex: 1 1 0;
  }

  .sales-toolbar-root .car-version-detail-col .caption {
    line-height: 1.25;
    margin-bottom: 0.125rem;
  }

  .sales-toolbar-root .car-version-detail-col .font-weight-bold {
    line-height: 1.4;
    word-break: break-word;
  }

  .sales-toolbar-root .car-search-combobox :deep(.v-field) {
    --v-field-padding-top: 10px;
    --v-field-padding-bottom: 10px;
    height: auto !important;
    min-height: 3.5rem;
  }

  .sales-toolbar-root .car-search-version-combobox :deep(.v-field) {
    --v-field-padding-top: 12px;
    --v-field-padding-bottom: 12px;
    min-height: 4.5rem;
  }

  .sales-toolbar-root .car-search-combobox :deep(.v-field__field) {
    height: auto !important;
    min-height: 3.5rem;
    align-items: flex-start;
  }

  .sales-toolbar-root .car-search-version-combobox :deep(.v-field__field) {
    min-height: 4.5rem;
  }

  .sales-toolbar-root .car-search-combobox :deep(.v-field__input) {
    white-space: normal;
    overflow: visible;
    align-items: flex-start;
    flex-wrap: wrap;
    min-height: unset;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .sales-toolbar-root .car-search-version-combobox :deep(.v-field__input) {
    display: block !important;
    height: auto !important;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .sales-toolbar-root .car-search-combobox :deep(.v-combobox__selection) {
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    width: 100%;
    max-width: 100%;
  }

  .sales-toolbar-root .car-search-version-combobox :deep(.v-combobox__selection) {
    display: block !important;
    width: 100%;
    position: static !important;
    transform: none !important;
  }

  .sales-toolbar-root .car-detail-selection {
    overflow: visible;
    width: 100%;
  }


  .sales-toolbar-root .car-version-detail-row,
  .sales-toolbar-root .car-version-detail-row--dropdown {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem 0.875rem;
    flex-wrap: unset;
  }

  .sales-toolbar-root .car-version-detail-col {
    flex: unset;
    padding: 0;
  }

  .sales-toolbar-root .car-version-detail-col--main {
    grid-column: 1 / -1;
    padding-bottom: 0.625rem;
    margin-bottom: 0.25rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }

  .sales-toolbar-root .car-version-detail-col--main .font-weight-bold {
    line-height: 1.45;
  }

  .sales-toolbar-root .car-detail-col {
    flex: 1 1 calc(50% - 0.5rem);
    max-width: none;
    min-width: 0;
    padding: 0;
    word-break: break-word;
  }

  .sales-toolbar-root .car-detail-selection.d-flex {
    flex-wrap: wrap;
    gap: 0.625rem 0.75rem;
  }
}
</style>
